import { SignInIcon } from "@phosphor-icons/react";

import * as auth0 from "@/auth/auth0";
import { toggleProd } from "@/env/env";
import { Button } from "@/ui/button";

export const AuthLogin = () => {
  const onProd = () => {
    toggleProd(true);
    auth0.login();
  };

  const onTest = () => {
    toggleProd(false);
    auth0.login();
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-blue-950">
      <div className="flex flex-col items-center gap-6 rounded-lg bg-white p-8">
        <div className="flex items-center gap-2">
          <SignInIcon size={24} />
          <h1 className="text-lg font-semibold">Select backend</h1>
        </div>
        <div className="flex gap-3">
          <Button onClick={onProd}>Log in to prod</Button>
          <Button onClick={onTest} variant="outline">
            Log in to test
          </Button>
        </div>
      </div>
    </div>
  );
};
